import api from "../api";

export const getAdminOrders = async (filters) => {
  const params = {
    page: filters.currentPage,
    page_size: filters.pageSize,
    tab: filters.tab,
  };

  if (filters.fulfillmentStatus) {
    params.fulfillment_status = filters.fulfillmentStatus;
  }

  if (filters.shipmentStatus) {
    params.shipment_status = filters.shipmentStatus;
  }

  if (filters.dateFrom) {
    params.date_from = filters.dateFrom;
  }

  if (filters.dateTo) {
    params.date_to = filters.dateTo;
  }

  if (filters.minAmount) {
    params.min_amount = filters.minAmount;
  }

  if (filters.maxAmount) {
    params.max_amount = filters.maxAmount;
  }

  if (filters.deliveryMethod) {
    params.delivery_method = filters.deliveryMethod;
  }

  if (filters.search) {
    params.search = filters.search;
  }

  if (filters.ordering) {
    params.ordering = filters.ordering;
  }

  const response = await api.get("operation/admin/orders/", { params });
  return response.data;
};

export const getAdminOrderDetail = async (orderId) => {
  const response = await api.get(`operation/admin/orders/${orderId}/`);
  return response.data;
};
